import { notifications } from "@mantine/notifications";

type NotificationParams = {
  title?: string;
  message?: string;
  color?: "info" | "error" | "success" | "warning";
  autoClose?: number;
  position?:
    | "top-center"
    | "top-right"
    | "top-left"
    | "bottom-center"
    | "bottom-right"
    | "bottom-left";
};

export function ShowNotification({
  title = "Info",
  message = "",
  color = "info",
  autoClose = 4000,
  position = "top-center",
}: NotificationParams) {
  notifications.show({
    title,
    message,
    color,
    autoClose,
    position,
  });
}
